import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'

import { SentryUserContext } from '@nebula/shared/components'
import { isChunkLoadErrorEvent, resolveSentryConfig } from '@nebula/shared/utils'

import App from './App'

import './index.css'

// DSN e `environment` saem de env var com fallback — ver `shared/utils/sentryConfig.ts`
// (issue #748: sem `environment`, o Sentry carimbava erro de `localhost` como produção).
const sentry = resolveSentryConfig(import.meta.env)

Sentry.init({
  dsn: sentry.dsn,
  environment: sentry.environment,
  enabled: sentry.enabled,
  sendDefaultPii: true,
  beforeSend(event) {
    if (isChunkLoadErrorEvent(event)) return null
    return event
  },
  initialScope: {
    tags: { app: 'nebula-hub' },
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <SentryUserContext />
        <App />
        <Toaster position="top-right" richColors />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
